// extracted by mini-css-extract-plugin
export default {"form-divider":"style_form-divider__D7Vr8","form-wrapper":"style_form-wrapper__Of63f"};